import styled from 'styled-components';

export const DivContainerDropdown = styled.div`
    width: auto;
    height: 35px;
    position: relative; /* Important pour que le menu se positionne par rapport à ce bloc */
    margin-right: 10px; /* Espace entre les éléments */

    /* Permet de cacher le premier ET/OU tout en gardant l'alignement */
    &.hidden-first-row {
        visibility: hidden;
        pointer-events: none;
    }
`

// Conteneur de la liste déroulante — flotte au-dessus du reste
export const DropdownMenu = styled.div`
    position: absolute;
    top: 38px; /* Juste en dessous du bouton */
    left: 0;
    width: 100%; /* Prend la même largeur que le bouton parent */
    z-index: 100;
    background-color: ${(props) => props.theme.surface};
    border: 1px solid ${(props) => props.theme.border};
    border-radius: ${(props) => props.theme.radius.sm};
    box-shadow: ${(props) => props.theme.shadowMd};
    /* Le menu défile sur lui-même : une longue liste (étoiles, villes…) ne file
       pas hors de l'écran, et ~8 options restent visibles d'un coup. */
    max-height: 280px;
    overflow-y: auto;
    overflow-x: hidden;

    &.active {
        display: block;
    }
    &.inactive {
        display: none;
    }
`

export const ButtonDropdown = styled.button`
    background-color: ${(props) => props.theme.surface};
    border: 1px solid ${(props) => props.theme.borderStrong};
    border-radius: ${(props) => props.theme.radius.sm};
    width: ${(props) => props.width || '150px'};
    padding: 0 10px;
    height: 35px;
    transition: background-color .12s ease;
    color: inherit;
    font-family: inherit;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.85rem;
    overflow: hidden;
    cursor: pointer;
    &:hover {
        background-color: ${(props) => props.theme.surface3};
    }
    &:disabled {
        background-color: ${(props) => props.theme.surface2};
        color: ${(props) => props.theme.text3};
        cursor: not-allowed;
    }
`

export const IconDropdown = styled.i``

export const LiDropdown = styled.li`
    list-style: none;
    font-size: 0.85rem;
    cursor: pointer;
    text-align: left;
    transition: background-color .12s ease;
    background-color: ${(props) => props.theme.surface};
    position: relative;
    padding: 6px 10px;
    width: 100%;
    box-sizing: border-box;

    &:hover {
        background-color: ${(props) => props.theme.surface3};
    }
`

export const InputAdvanced = styled.input`
    background-color: ${(props) => props.theme.surface};
    border: 1px solid ${(props) => props.theme.borderStrong};
    border-radius: ${(props) => props.theme.radius.sm};
    height: 35px;
    padding: 0 10px;
    margin: 0 10px 0 0;
    color: inherit;
    font-family: inherit;
    font-size: 0.85rem;
    width: 300px;
    box-sizing: border-box;
    transition: border-color 0.12s ease;
    &:focus {
        outline: none;
        border-color: ${(props) => props.theme.accent};
    }
    &::placeholder {
        color: ${(props) => props.theme.text3};
    }
`

export const ButtonRemoveRow = styled.button`
    background-color: ${(props) => props.theme.surface};
    border: 1px solid ${(props) => props.theme.borderStrong};
    border-radius: ${(props) => props.theme.radius.sm};
    height: 35px;
    transition: background-color .12s ease;
    font-size: inherit;
    color: inherit;
    font-family: inherit;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    cursor: pointer;
    padding: 0px 10px;
    margin-left: 10px;
    &:hover {
        background-color: ${(props) => props.theme.surface3};
    };
    &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`
